<script lang="ts" setup>
import { LoaderOverlay } from '@shared/ui/loaders'

defineOptions({
  name: 'SkeletonSectionDemo',
})

</script>

<template>
  <div class="demo skeleton">
    <LoaderOverlay />
  </div>
</template>

<style scoped lang="scss" src="./SkeletonSectionDemo.scss" />
